import axios from "axios";
import store from "@/store";
import { AuthError } from "./error_service";

const laravelApi = axios.create({
  baseURL: process.env.VUE_APP_API_LARAVEL_URL
});

laravelApi.interceptors.request.use(config => {
  const token = (store.state as any).global.authToken;
  if (token) {
    config.headers!.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * A 401 on an authenticated request means the Sanctum token is expired or
 * revoked. Most callers swallow errors (the NetSuite lookups return [] and the
 * app carries on looking logged in with no data), so the session is ended here
 * for every caller rather than per call site. The error is still rejected so
 * callers unwind as before.
 *
 * Exempt: requests sent without a token, and the code exchange / logout calls,
 * whose 401s mean a bad SSO code or an already-dead session, not expiry.
 */
const authExempt = ["/api/auth/exchange", "/api/auth/logout"];

laravelApi.interceptors.response.use(undefined, err => {
  const sentToken = !!err?.config?.headers?.Authorization;
  const url: string = err?.config?.url || "";
  if (
    err?.response?.status === 401 &&
    sentToken &&
    !authExempt.some(path => url.includes(path))
  ) {
    AuthError.logout();
  }
  return Promise.reject(err);
});

export default laravelApi;
